import {useEffect, useState} from 'react';
import {BrowserRouter, Routes as Router, Route, useNavigate} from 'react-router-dom';
import TirarPedido from './components/Paginas/TirarPedido';
import HomePage from "./components/Paginas/HomePage";
import Login from './components/Login';
import CarregaPreDefinicoes from './components/subComponents/CarregaPreDefinicoes';
import ConsultarPedidosVendedoras from './components/Paginas/ConsultarPedidosVendedoras';
import AtualizaPecasEncomenda from './components/Paginas/AtualizaPecasEncomenda/AtualizaPecasEncomenda';
import PedidoRelatorioRomaneio from './components/Paginas/PedidoRelatorioRomaneio';
import CorteDePecasFornecedor from './components/Paginas/CorteDePecasFornecedor';
import GlobalVar from './components/subComponents/GlobalVar';
import PedidoRelatorioCliente from './components/Paginas/PedidoRelatorioCliente';
import GeraPdfProdutoImpressao from './components/Paginas/GeraPdfProdutoImpressao';

function Routes(){

    const [ativaResp, setAtivaResp] = useState(null) // Seta variavel responsividade
    
    useEffect(() => {
    const CACHE_FLAG = "cache_ok";

    const clearCache = async () => {
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }

      // marca que já limpou
      localStorage.setItem(CACHE_FLAG, "true");

      // força reload limpo
      window.location.reload();
    };

    if (!localStorage.getItem(CACHE_FLAG)) {
      clearCache();
    }
  }, []);

    useEffect(()=>{
            if (ativaResp == null){
                if (window.matchMedia("(max-width: 767px)").matches){
                setAtivaResp(true)
                }else{
                    setAtivaResp(false)
                }
            }
        },[ativaResp])

        useEffect(() => {
            const url = window.location.pathname;
            console.log("CARRENGANDO")
            if(!GlobalVar.getSessionStorage('usuario') && !["/", "/Logar", "/Sair", "/PedidoRelatorioCliente"].includes(url)){
                window.location.href = '/'
            }
          }, []);

          useEffect(() => {
            let startY = 0;
        
            const handleTouchStart = (e) => {
              startY = e.touches[0].clientY;
            };
        
            const handleTouchMove = (e) => {
              const currentY = e.touches[0].clientY;
        
              if (window.scrollY === 0 && currentY > startY) {
                e.preventDefault(); // impede pull-to-refresh
              }
            };
        
            document.addEventListener("touchstart", handleTouchStart);
            document.addEventListener("touchmove", handleTouchMove, {
              passive: false,
            });
        
            return () => {
              document.removeEventListener("touchstart", handleTouchStart);
              document.removeEventListener("touchmove", handleTouchMove);
            };
          }, []);



          useEffect(() => {
            const CACHE_FLAG = "cache_150526";
        
            const clearCache = async () => {
              if ("caches" in window) {
                const keys = await caches.keys();
                await Promise.all(keys.map((key) => caches.delete(key)));
              }
        
              // marca que já limpou
              localStorage.setItem(CACHE_FLAG, "true");
        
              // força reload limpo
              window.location.reload();
            };
        
            if (!localStorage.getItem(CACHE_FLAG)) {
              clearCache();
            }
          }, []);
          

    return(
        <BrowserRouter>
            <Router>
                <Route path="/" element={<Login />}/>
                <Route path="/Logar" element={<Login />}/>
                <Route path="/Sair" element={<Login />}/>
                <Route path="/Carregando" element={<CarregaPreDefinicoes />}/>
                <Route path="/HomePage" element={<HomePage ativaResp={ativaResp} showStyle={true}/>}/>
                {/* <Route path="/HomePage" element={<TirarPedido ativaResp={ativaResp} showStyle={true}/>}/> */}
                <Route path="/ConsultarPedidosVendedoras" element={<ConsultarPedidosVendedoras ativaResp={ativaResp} showStyle={true}/>}/>
                <Route path="/TirarPedido" element={<TirarPedido ativaResp={ativaResp} showStyle={true}/>}/>
                <Route path="/PecasEncomenda" element={<AtualizaPecasEncomenda ativaResp={ativaResp} showStyle={true}/>}/>
                <Route path="/PedidoRelatorioRomaneio" element={<PedidoRelatorioRomaneio ativaResp={ativaResp} showStyle={true}/>}/>
                <Route path="/CorteDePecasFornecedor" element={<CorteDePecasFornecedor ativaResp={ativaResp} showStyle={true}/>}/>
                <Route path="/GeraPdfProdutoImpressao" element={<GeraPdfProdutoImpressao ativaResp={ativaResp} showStyle={true}/>}/>

                <Route path="/PedidoRelatorioCliente" element={<PedidoRelatorioCliente ativaResp={ativaResp} showStyle={true}/>}/>
                
                
            </Router>
        </BrowserRouter>
    );
 };
export default Routes;

